<div class="modal-header">
  <h4 class="modal-title">Submenu</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">

  </button>
</div>

<div class="modal-body">
  <form [formGroup]="menuForm" (ngSubmit)="onFormSubmit()" id="ngForm">

    <div class="row">
      <div class="col-md-6">
        <label class="form-label">Module <span class="text-danger">*</span></label>
        <ng-select
                [loading]="waitingModule"
                [items]="modules"
                bindLabel="name"
                bindValue="id"
                placeholder="Choose a module"
                formControlName="module"
                [ngClass]="{'is-invalid': fc['module'].invalid && isSubmitted}"
                [(ngModel)]="moduleSelected"
                (change)="applyModuleFilter($event)">
        </ng-select>

        <div class="invalid-feedback" *ngIf="fc['module'].errors?.['required']">This field is required</div>
        <div class="invalid-feedback" *ngIf="fc['module'].errors?.['serverError']">
          {{ fc['module'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="col-md-3">
        <label class="form-label">{{'type'|translate}} <span class="text-danger">*</span></label>
        <ng-select
                [items]="types"
                bindLabel="title"
                bindValue="name"
                placeholder="{{'choose a type'|translate}}"
                formControlName="type"
                [ngClass]="{'is-invalid': fc['type'].invalid && isSubmitted}"
                [(ngModel)]="typeSelected"
                [readonly]="true">
        </ng-select>
        <div class="invalid-feedback" *ngIf="fc['type'].errors?.['required']">{{'this field is required'|translate}}</div>
        <div class="invalid-feedback" *ngIf="fc['type'].errors?.['serverError']">
          {{ fc['type'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="col-md-3">
        <label class="form-label">Position </label>
        <input class="form-control form-control-sm" type="number" placeholder="Ex. 10" formControlName="position" [ngClass]="{'is-invalid': fc['position'].invalid && isSubmitted}">
        <div class="invalid-feedback" *ngIf="fc['position'].errors?.['serverError']">
          {{ fc['position'].errors?.['serverError'] }}
        </div>
      </div>

    </div>

    <div class="row mt-2">
      <div class="col-md-6">
        <label class="form-label">Path</label>
        <input class="form-control form-control-sm" type="text" placeholder="Ex. /security/" formControlName="path" [ngClass]="{'is-invalid': fc['path'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['path'].errors?.['required']">This field is required</small>
        <div class="invalid-feedback" *ngIf="fc['path'].errors?.['serverError']">
          {{ fc['path'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label">Name <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm bg-gradient" type="text" placeholder="Ex. Menu" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">This field is required</small>
        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['minlength']">Name must be at least 3 characters long</div>
        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['serverError']">
          {{ fc['name'].errors?.['serverError'] }}
        </div>
      </div>


    </div>

    <div class="row mt-2">
      <div class="col-md-6">
        <label class="form-label">Parent <span class="text-danger">*</span></label>
        <ng-select
                [loading]="waitingParent"
                [items]="parentsFiltered"
                bindLabel="name"
                bindValue="id"
                placeholder="Choose a parent"
                formControlName="parent"
                [ngClass]="{'is-invalid': fc['parent'].invalid && isSubmitted}"
                [(ngModel)]="parentSelected">

        </ng-select>
        <div class="invalid-feedback" *ngIf="fc['parent'].errors?.['required']">This field is required</div>
        <div class="invalid-feedback" *ngIf="fc['parent'].errors?.['serverError']">
          {{ fc['parent'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label">Permissions</label>
        <ng-select
                [items]="permissions"
                bindLabel="name"
                bindValue="id"
                placeholder="Choose a permission"
                formControlName="permissions"
                [multiple]="true"
                [ngClass]="{'is-invalid': fc['permissions'].invalid && isSubmitted}"
                [(ngModel)]="permissionsSelected"
        >
        </ng-select>
        <div class="invalid-feedback" *ngIf="fc['permissions'].errors?.['required']">This field is required</div>
        <div class="invalid-feedback" *ngIf="fc['permissions'].errors?.['serverError']">
          {{ fc['permissions'].errors?.['serverError'] }}
        </div>
      </div>

    </div>
      <div class="row mt-2">
          <div class="col-md-6">
              <label class="form-label">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
              <div class="btn-radio" >
                  <div class="btn-group" data-bs-toggle="buttons">
                      <div class="btn btn-light txt-dark">
                          <div class="radio radio-dark">
                              <input id="radio21" formControlName="isEnable" type="radio" value='1'>
                              <label for="radio21">{{ 'yes'|translate }}</label>
                          </div>
                      </div>
                      <div class="btn btn-light txt-dark">
                          <div class="radio radio-dark">
                              <input id="radio22" formControlName="isEnable" type="radio" value='0'>
                              <label for="radio22">{{ 'no'|translate }}</label>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>

  <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-outline-primary" [disabled]=saving>
    <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>
    <ng-template #isSaving>
      {{ "Submitting" | translate}} ...
    </ng-template>
  </button>

</div>














